import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { Birthdays } from '@store/models';

@Component({
    selector: 'app-birthdays',
    templateUrl: './birthdays.component.html',
    styleUrls: ['./birthdays.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})

export class BirthdaysComponent {

    @Input() birthDays: Birthdays;
    @Output() selectClient = new EventEmitter<number>();
    @Output() allBirthdays = new EventEmitter();

    onSelectClient(kid: number) {
        this.selectClient.emit(kid);
    }

    onAll() {
        this.allBirthdays.emit();
    }

}
